import React from "react";
import { subDays, getDaysInMonth } from "date-fns";
import { makeStyles, Tooltip } from "@material-ui/core";
import {
  numDifferentiation,
  percentageCalc,
  formatToCommaString,
} from "./helper/format";

const useStyle = makeStyles((theme) => {
  return {
    widget: {
      background: "white",
      borderRadius: theme.spacing(1.5),
      margin: theme.spacing(1),
      width: "calc(50% - 16px)",
      padding: theme.spacing(2),

      [theme.breakpoints.down("md")]: {
        width: "calc(100% - 16px)",
      },
    },
    widgetHeader: {
      color: "rgba(0, 14, 61, 1)",
      fontSize: 20,
      fontWeight: 700,
      margin: theme.spacing(0, 1),
      display: "flex",
      justifyContent: "space-between",
    },
    chartWrapper: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      marginTop: 12,
    },
    wrapper: {
      display: "flex",
      width: "100%",
      padding: theme.spacing(0, 2),
      marginBottom: 10,
    },
    clickableWrapper: {
      display: "flex",
      width: "100%",
      padding: theme.spacing(1, 2),
      marginBottom: 5,
      marginTop: 5,
      "&:hover": {
        background: "#ffeff6",
        cursor: "pointer",
      },
    },
    tooltip: {
      fontSize: 16,
    },
    item: {
      fontFamily: "Inter",
      width: "10%",
      color: "#362B73",
      fontWeight: 500,
      fontSize: 14,
      paddingTop: 5,
      paddingBottom: 5,
    },
  };
});

export default function TargetVsAchivementWidget({
  element,
  tabIndex: rootTabIndex,
  isInEligibleTab,
  isLast,
  lastParsedTime,
  isClickable,
  onClickWidget,
}) {
  const classes = useStyle();

  const calculateTarget = (target) => {
    const yesterday = subDays(new Date(lastParsedTime), 1);
    const totalDaysInMonth = getDaysInMonth(yesterday);
    const daysPassed = yesterday.getDate();

    //console.log(daysPassed, totalDaysInMonth, lastParsedTime);

    if (rootTabIndex === 0)
      return Math.ceil((target * daysPassed) / totalDaysInMonth);

    return target;
  };

  const calculateAchivedPercentage = () => {
    if (isInEligibleTab) {
      return percentageCalc(element.achievementEligible, target);
    }

    return percentageCalc(element.achived, target);
  };

  const target = calculateTarget(element.target);

  return (
    <div
      className={isClickable ? classes.clickableWrapper : classes.wrapper}
      onClick={isClickable ? onClickWidget : () => {}}
    >
      <div className={classes.item} style={{ width: "20%" }}>
        {element.header}
      </div>
      <Tooltip
        classes={{ tooltip: classes.tooltip }}
        placement="top"
        title={formatToCommaString(target)}
      >
        <div className={classes.item} style={{ textAlign: "center" }}>
          {numDifferentiation(target)}
        </div>
      </Tooltip>
      <Tooltip
        classes={{ tooltip: classes.tooltip }}
        placement="top"
        title={formatToCommaString(
          isInEligibleTab ? element.achievementEligible : element.achived
        )}
      >
        <div className={classes.item} style={{ textAlign: "center" }}>
          {numDifferentiation(
            isInEligibleTab ? element.achievementEligible : element.achived
          )}
        </div>
      </Tooltip>
      <div
        className={classes.item}
        style={{ color: "#E2136E", textAlign: "center" }}
      >
        {calculateAchivedPercentage().toFixed(2) + "%"}
      </div>
      <div
        style={{
          width: "50%",
          marginLeft: 12,
          display: "flex",
          alignItems: "center",
        }}
      >
        <div
          style={{
            width: "100%",
            padding: "4px",
            background: "#F3F5FA",
            borderRadius: 16,
            boxShadow: "2px 2px 4px 0px rgba(54, 43, 115, 0.08) inset",
            filter: "drop-shadow(2px 2px 1px 0px rgba(255, 255, 255, 1))",
          }}
        >
          <div
            style={{
              width: `${Math.min(calculateAchivedPercentage(), 100)}%`,
              background:
                "linear-gradient(90deg, #FF95EE 0%, #FA66BC 51%, #F53689 100%)",
              height: 16,
              borderRadius: 16,
            }}
          ></div>
        </div>
        {false && !isLast && (
          <div style={{ display: "flex", width: "100%", marginLeft: "-12px" }}>
            {[0, 1, 2, 3, 4, 5, 6, 7, 8, 9].map((n) => (
              <div
                key={n}
                style={{
                  borderRight: "1px solid  rgba(54, 43, 115, 0.08)",
                  height: 16,
                  width: "10%",
                }}
              ></div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
